import React from 'react'
import { Link } from 'react-router-dom'
import abuso_sustancias from '../assets/images/psicologo/abuso_sustancias.jpg'
import Navbar from '../components/navbar'
import Shape from '../components/shape'
import ShapeTwo from '../components/shape-two'
import Footer from '../components/footer'
import bg2 from '../assets/images/Brochure_Deymed_Duomag/3.png'
import bg1 from '../assets/images/bg.jpg'
import fondo from '../assets/images/Brochure_Neuroelectrics/7.png'

export default function PageTerm() {
  return (
    <>
     <Navbar/>
     
    <section className="bg-half-170 bg-light d-table w-100" style={{backgroundImage:`url(${fondo})`, backgroundPosition:'center'}}>
      <div className="bg-overlay"></div>
      <div className="container">
          <div className="row mt-5 text-center align-items-center">
              <div className="col-sm-6">
                  <div className="text-sm-start">
                      <div className="page-next-level">
                          <h4 className="title text-white">Estimulación Eléctrica Transcraneal</h4>
                          <p className="text-muted mb-0">Características, aplicaciones y procedimientos</p>                                        
                      </div>
                  </div>
              </div>

              <div className="col-sm-6 mt-4 mt-sm-0 pt-2 pt-sm-0">
                  <div className="page-next-level text-sm-end">
                      <ul className="page-next ps-0 mb-0">
                          <li className="list-inline-item"><Link to="/" className="fw-bold text-white">Inicio</Link></li>
                          <li className="list-inline-item"><Link to="#" className="fw-bold text-white">Servicios</Link></li>
                          <li className="list-inline-item">
                              <span className="text-primary fw-bold">tDCS</span> 
                          </li> 
                      </ul>
                  </div>
              </div>
          </div>
      </div> 
    </section>
    <ShapeTwo/>
    <section className="section">
  <div className="container">
    <div className="row justify-content-center" style={{textAlign:'justify', padding:20}}>
      <div className="col-12">
        <h4>Introducción</h4>
        <p className="text-muted">
          La Estimulación eléctrica transcraneal por corriente directa (tDCS) es una técnica de neuromodulación no invasiva que utiliza una corriente eléctrica de baja intensidad para estimular o inhibir la actividad cerebral.
        </p>
        <br />
        <h4 className='text-warning'>Características principales</h4>
        <p className="text-muted">
          <i className="mdi mdi-chevron-double-right me-2"></i>
          No invasiva: Al igual que la rTMS, no requiere de cirugía.
        </p>
        <p className="text-muted">
          <i className="mdi mdi-chevron-double-right me-2"></i>
          Mecanismo de acción: Se colocan dos electrodos (uno ánodo y otro cátodo) sobre la cabeza del paciente. El ánodo (positivo) aumenta la excitabilidad neuronal, mientras que el cátodo (negativo) la disminuye. La corriente eléctrica viaja entre los dos electrodos a través del cuero cabelludo y el cráneo, afectando la actividad de las neuronas en las áreas objetivo del cerebro.
        </p>
        <p className="text-muted">
          <i className="mdi mdi-chevron-double-right me-2"></i>
          Intensidad de la corriente: Utiliza corrientes muy débiles, generalmente entre 1 y 2 miliamperios.
        </p>
        <p className="text-muted">
          <i className="mdi mdi-chevron-double-right me-2"></i>
          Aplicaciones principales: Se ha investigado y utilizado en el tratamiento de una variedad de condiciones, incluyendo la depresión, el dolor crónico, la rehabilitación post-ictus, la mejora cognitiva y el control de los síntomas del parkinson.
        </p>
        <p className="text-muted">
          <i className="mdi mdi-chevron-double-right me-2"></i>
          Procedimiento: Las sesiones de tDCS suelen ser cortas, durando aproximadamente de 15 a 30 minutos. A menudo se combina con otras terapias, como la fisioterapia o la terapia ocupacional, para potenciar sus efectos.
        </p>
        <br />
        <h4>Conclusión</h4>
        <p className="text-muted">
          La tDCS es una técnica de bajo costo y fácil aplicación que modula la actividad cerebral para objetivos terapéuticos o de investigación, ofreciendo un enfoque complementario en el tratamiento de diversas condiciones neurológicas y psiquiátricas.
        </p>
      </div>
    </div>
  </div>
</section>
    <Footer/>
    </>
  )
}
